module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/writ-of-election-issued.jpg?v=51f44531";